import {Component, Input} from "@angular/core";
import {FuelStationColumnType} from "../../../../pages/client/poi/fuel-stations/model/fuel-station.entry";
import {FormControl} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-undo-reason',
  templateUrl: './undo-reason.component.html',
  styleUrls: ['./undo-reason.component.scss']
})
export class UndoReasonComponent {

  @Input()
  public inputType: FuelStationColumnType;
  @Input()
  public inputTitle: string;

  public inputForm = new FormControl();

  constructor(public activeModal: NgbActiveModal) {
  }

}
